import { BlockTitle } from "@blocks/Blocks";
import ButtonFactory from "@components/Button/ButtonFactory";
import { ButtonType } from "@components/Button/utils/types";
import IconFactory from "@components/Icon/IconFactory";
import { IconTypeEnum } from "@components/Icon/utils/types";
import useDropdown from "@hooks/useDropdown";
import useTabs from "@hooks/useTabs";
import { HowToNominateTabsFactory } from "@sca/components/HowToNominate/utils/helper";
import { NOMINATIONS_TAB } from "@sca/components/SCAconstants";
import { cn } from "@util/helpers";

import NominationsTabMobile from "./NominationsTabMobile";
import NominationsTabDesktop from "./NominationTabDesktop";

/**
 * Component to render SCA How to Nominate page
 */
const SCAHowToNominatePage = (): React.ReactElement => {
  const { isOpen, toggleDropdown, closeDropdown } = useDropdown();
  const { activeTab, activeLabel, changeTab } = useTabs(NOMINATIONS_TAB);

  const HowToNominateTabs = HowToNominateTabsFactory(activeTab);

  return (
    <div data-testid="how-to-nominate-page-component">
      <div className="relative mb-5 w-full font-public-sans lg:hidden">
        <ButtonFactory
          buttonType={ButtonType.Secondary}
          text={activeLabel}
          icon={
            <IconFactory
              type={IconTypeEnum.arrowDown}
              x={20}
              y={22}
              size={20}
            />
          }
          iconPosition="right"
          onClick={toggleDropdown}
          className={cn(
            "flex w-full items-center justify-between rounded-full border border-black bg-white px-4 py-2 font-semibold hover:underline",
            { "text-black underline": isOpen }
          )}
        />

        {isOpen ? (
          <NominationsTabMobile
            activeLabel={activeLabel}
            changeTab={changeTab}
            closeDropdown={closeDropdown}
          />
        ) : null}
      </div>

      <NominationsTabDesktop activeTab={activeTab} changeTab={changeTab} />

      <BlockTitle
        text={NOMINATIONS_TAB.find((t) => t.key === activeTab)?.label || ""}
        rootClassName="text-4xl md:text-6xl lg:text-8xl font-medium mb-5"
      />

      {HowToNominateTabs ? <HowToNominateTabs /> : null}
    </div>
  );
};

export default SCAHowToNominatePage;
